import React, { useState } from "react";
import PropTypes from "prop-types";
import "../css/theme.css";
import "../css/addCreditor.css";

const AddDebitor = ({ onSubmit }) => {
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [preferredBank, setPreferredBank] = useState("");
  const [paymentInterval, setPaymentInterval] = useState("");
  const [creditLimit, setCreditLimit] = useState("");
  const [creditDays, setCreditDays] = useState("");
  const [notes, setNotes] = useState("");

  const [contact2, setContact2] = useState("");
  const [designation2, setDesignation2] = useState("");
  const [whatsapp2, setWhatsapp2] = useState("");

  const [contact3, setContact3] = useState("");
  const [designation3, setDesignation3] = useState("");
  const [whatsapp3, setWhatsapp3] = useState("");

  const [contact4, setContact4] = useState("");
  const [designation4, setDesignation4] = useState("");
  const [whatsapp4, setWhatsapp4] = useState("");

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const isTenDigitOrEmpty = (val) =>
    val.trim() === "" || /^\d{10}$/.test(val.trim());

  const validateInputs = () => {
    if (!name.trim()) {
      setError("Name is required.");
      return false;
    }
    if (!address.trim()) {
      setError("Address is required.");
      return false;
    }
    if (!/^\d{10}$/.test(phoneNumber.trim())) {
      setError("Phone number must be exactly 10 digits.");
      return false;
    }

    if (
      paymentInterval &&
      (!Number.isInteger(Number(paymentInterval)) || Number(paymentInterval) < 0)
    ) {
      setError("Payment interval must be a non-negative whole number.");
      return false;
    }

    if (creditLimit && (isNaN(creditLimit) || Number(creditLimit) < 0)) {
      setError("Credit limit must be a positive number.");
      return false;
    }

    if (
      creditDays &&
      (!Number.isInteger(Number(creditDays)) || Number(creditDays) < 0)
    ) {
      setError("Credit days must be a non-negative whole number.");
      return false;
    }

    if (!isTenDigitOrEmpty(whatsapp2)) {
      setError("WhatsApp 2 must be 10 digits if provided.");
      return false;
    }
    if (!isTenDigitOrEmpty(whatsapp3)) {
      setError("WhatsApp 3 must be 10 digits if provided.");
      return false;
    }
    if (!isTenDigitOrEmpty(whatsapp4)) {
      setError("WhatsApp 4 must be 10 digits if provided.");
      return false;
    }

    setError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateInputs()) return;

    const confirmSubmit = window.confirm(
      "Do you want to change any details? Press 'Cancel' to review before submitting."
    );
    if (!confirmSubmit) return;

    // IMPORTANT: keys must match DB columns
    const debitor = {
      name: name.trim(),
      address: address.trim(),
      phoneNumber: phoneNumber.trim(),
      preferredBank: preferredBank || null,
      paymentInterval: paymentInterval
        ? parseInt(paymentInterval, 10)
        : null,
      creditLimit: creditLimit ? parseFloat(creditLimit) : null,
      creditDays: creditDays ? parseInt(creditDays, 10) : null,
      notes: notes || null,

      contactName2: contact2 || null,
      contactDesignation2: designation2 || null,
      whatsapp2: whatsapp2 || null,

      contactName3: contact3 || null,
      contactDesignation3: designation3 || null,
      whatsapp3: whatsapp3 || null,

      contactName4: contact4 || null,
      contactDesignation4: designation4 || null,
      whatsapp4: whatsapp4 || null,
    };

    try {
      const response = await fetch("/api/debitors.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(debitor),
      });

      if (!response.ok) {
        throw new Error("Failed to add debitor. Please try again.");
      }

      const newDebitor = await response.json();
      setSuccess("Debitor added successfully!");
      setTimeout(() => setSuccess(""), 2000);

      // Reset all fields
      setName("");
      setAddress("");
      setPhoneNumber("");
      setPreferredBank("");
      setPaymentInterval("");
      setCreditLimit("");
      setCreditDays("");
      setNotes("");

      setContact2("");
      setDesignation2("");
      setWhatsapp2("");

      setContact3("");
      setDesignation3("");
      setWhatsapp3("");

      setContact4("");
      setDesignation4("");
      setWhatsapp4("");

      if (onSubmit) onSubmit(newDebitor);
    } catch (err) {
      setError(err.message || "An error occurred. Please try again.");
    }
  };

  return (
    <div className="ac-container">
      <h2 className="ac-title">Add Debitor</h2>

      {error && <div className="ac-alert ac-alert-danger">{error}</div>}
      {success && <div className="ac-alert ac-alert-success">{success}</div>}

      <form onSubmit={handleSubmit} className="ac-form">
        {/* Primary Details */}
        <div className="ac-section">
          <h4>Primary Details</h4>

          <div className="ac-grid">
            <div className="ac-field">
              <label>Name</label>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="ac-field">
              <label>Phone Number</label>
              <input
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </div>

            <div className="ac-field">
              <label>Address</label>
              <input
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Other Contacts */}
        <div className="ac-section">
          <h4>Other Contact Persons</h4>

          <div className="ac-grid">
            <div className="ac-field">
              <label>Contact Name 2</label>
              <input
                value={contact2}
                onChange={(e) => setContact2(e.target.value)}
              />
            </div>
            <div className="ac-field">
              <label>Designation 2</label>
              <input
                value={designation2}
                onChange={(e) => setDesignation2(e.target.value)}
              />
            </div>
            <div className="ac-field">
              <label>WhatsApp 2</label>
              <input
                value={whatsapp2}
                onChange={(e) => setWhatsapp2(e.target.value)}
              />
            </div>
          </div>

          <div className="ac-grid">
            <div className="ac-field">
              <label>Contact Name 3</label>
              <input
                value={contact3}
                onChange={(e) => setContact3(e.target.value)}
              />
            </div>
            <div className="ac-field">
              <label>Designation 3</label>
              <input
                value={designation3}
                onChange={(e) => setDesignation3(e.target.value)}
              />
            </div>
            <div className="ac-field">
              <label>WhatsApp 3</label>
              <input
                value={whatsapp3}
                onChange={(e) => setWhatsapp3(e.target.value)}
              />
            </div>
          </div>

          <div className="ac-grid">
            <div className="ac-field">
              <label>Contact Name 4</label>
              <input
                value={contact4}
                onChange={(e) => setContact4(e.target.value)}
              />
            </div>
            <div className="ac-field">
              <label>Designation 4</label>
              <input
                value={designation4}
                onChange={(e) => setDesignation4(e.target.value)}
              />
            </div>
            <div className="ac-field">
              <label>WhatsApp 4</label>
              <input
                value={whatsapp4}
                onChange={(e) => setWhatsapp4(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Additional Details */}
        <div className="ac-section">
          <h4>Additional Details</h4>

          <div className="ac-grid">
            <div className="ac-field">
              <label>Preferred Bank</label>
              <input
                value={preferredBank}
                onChange={(e) => setPreferredBank(e.target.value)}
              />
            </div>

            <div className="ac-field">
              <label>Payment Interval (Days)</label>
              <input
                type="number"
                value={paymentInterval}
                onChange={(e) => setPaymentInterval(e.target.value)}
              />
            </div>

            <div className="ac-field">
              <label>Credit Limit</label>
              <input
                type="number"
                value={creditLimit}
                onChange={(e) => setCreditLimit(e.target.value)}
              />
            </div>

            <div className="ac-field">
              <label>Credit Days</label>
              <input
                type="number"
                value={creditDays}
                onChange={(e) => setCreditDays(e.target.value)}
              />
            </div>
          </div>

          <div className="ac-field">
            <label>Notes</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </div>
        </div>

        <button type="submit" className="ac-btn">
          ➕ Add Debitor
        </button>
      </form>
    </div>
  );
};

AddDebitor.propTypes = {
  onSubmit: PropTypes.func,
};

export default AddDebitor;